/** Period-lock warning shown inside drawers that pick a posting date. When
 * the chosen date falls on or before the lock date, the backend rejects the
 * write with a 409 (`locked_period`) — this explains that before submit. */
export function PeriodLockWarning({
  lockDate,
  chosenDate,
}: {
  lockDate?: string;
  chosenDate: string;
}) {
  if (!lockDate || !chosenDate) return null;
  if (chosenDate > lockDate.slice(0, 10)) return null;
  return (
    <p role="alert" className="notice notice--danger">
      This date ({chosenDate}) falls in a locked accounting period (locked up to{" "}
      {lockDate.slice(0, 10)}). Saving will be rejected — pick a later date or
      ask an admin to review Period locks in Settings.
    </p>
  );
}
